module.exports = __webpack_public_path__ + "img/parallax-two.174e69a.webp";